export default function useStaticData(staticData) {
  const {
    /* productApplications, */ productImages,
    applicationModels,
    ApitchList,
    ArebarList,
    applicationInsertDiameterList,
    adhesiveAnchorListOption,
    applicationInsertDiameterProductList,
    applicationDrillBitDiameterList,
    applicationScreenTubeList,
    waterFilledHolesDependencyList,
    productInfo,
    injectionResinFullList,
    injectionResinCrackWidthList,
    crackInjectionApplicationModels,
    crackInjectionFootnotes,
  } = staticData

  const getModels = (product) => {
    if (!applicationModels) {
      return []
    }
    return applicationModels.reduce((result, item) => {
      if (item.product === product) {
        const myItem = getProductImage(item.model)
        if (myItem) {
          item.productUrl = myItem.productUrl
        } else {
          console.log('missing productUrl: ', item.model)
        }
        result.push(item)
      }
      return result
    }, [])
  }

  //getting either Apitch or Arebar
  const getApitchOrArebar = (insertDiameter, insertType) => {
    switch (insertType) {
      case 'Rebar':
        return ArebarList.find((item) => item.insertDiameter === insertDiameter).Arebar
      default:
        return ApitchList.find((item) => item.insertDiameter === insertDiameter).Apitch
    }
  }

  const getInsertDiameterOptions = (application) => {
    if (!applicationInsertDiameterList) {
      return []
    }

    const x = applicationInsertDiameterList.find((item) => item.insertType === application)
    if (x) {
      return x.insertDiameterList
    } else {
      return []
    }
  }

  const getProductOptions = (application, insertDiameter) => {
    if (!applicationInsertDiameterProductList) {
      return []
    }

    const x = applicationInsertDiameterProductList.find((item) => item.insertType === application)
    if (x) {
      const y = x.insertDiameterProductList.find((item) => item.insertDiameter === insertDiameter)
      if (y) {
        return adhesiveAnchorListOption[y.productList]
      }
    }
    return []
  }

  const getDrillBitDiameterOptions = (product, application, insertDiameter) => {
    if (!applicationDrillBitDiameterList) {
      return []
    }

    const x = applicationDrillBitDiameterList.find(
      (item) => item.product === product && item.insertType === application,
    )
    if (x) {
      const y = x.drillBitDiameterListByInsertType.find(
        (item) => item.insertDiameter === insertDiameter,
      )
      if (y) {
        return y.drillBitDiameterList
      }
    }
    return []
  }

  const getScreenTubeOptions = (product, application, insertDiameter) => {
    if (!applicationScreenTubeList) {
      return []
    }

    const x = applicationScreenTubeList.find(
      (item) => item.product === product && item.insertType === application,
    )
    if (x) {
      const y = x.screenTubeListByInsertType.find((item) => item.insertDiameter === insertDiameter)
      if (y) {
        return y.screenTubeList
      }
    }
    return []
  }

  const getInjectionResinCrackWidthList = (crackWidth) => {
    if (!injectionResinCrackWidthList) {
      return []
    }

    const x = injectionResinCrackWidthList.find((item) => item.crackWidth === crackWidth)
    if (x && x.injectionResinList) {
      const list = x.injectionResinList.map((item) => {
        return injectionResinFullList[item]
      })
      return list
    } else {
      return []
    }
  }

  const getCrackInjectionModels = (product) => {
    if (!crackInjectionApplicationModels) {
      return []
    }
    return crackInjectionApplicationModels.reduce((result, item) => {
      if (item.product === product) {
        const myItem = getProductImage(item.model)
        // console.log(item.model, myitem.productUrlItem)
        if (myItem && !item.productUrl) {
          // console.log('--', item.model)
          if(!item.productUrl)  item.productUrl = myItem.productUrl
          if(!item.productUrlEC) item.productUrlEC = myItem.productUrlEC
        } else {
          // console.log('missing productUrl: ', item.model)
        }
        result.push(item)
      }
      return result
    }, [])
  }

  const getProductImages = (names) => {
    if (!productImages) {
      return []
    }
    return names.reduce((result, name) => {
      const x = productImages.find((item) => item.name === name)
      if (x) {
        result.push(x)
      }
      return result
    }, [])
  }

  const getProductImage = (name) => {
    if (!productImages) {
      return null
    }

    const x = productImages.find((item) => item.name === name)
    if (x) {
      return x
    }

    return null
  }

  const showWaterFilledHolesInput = (application, product) => {
    if (!waterFilledHolesDependencyList) {
      return false
    }

    const x = waterFilledHolesDependencyList.find(
      (item) => item.product === product && item.insertType === application,
    )
    if (x) {
      return true
    } else {
      return false
    }
  }

  const getProductInfo = (product) => {
    if (!productInfo) {
      return null
    }

    const x = productInfo.find((item) => item.product === product)
    if (x) {
      return x
    }
    return null
  }

  const getCrackInjectionFootnotes = (products) => {
    if (!crackInjectionFootnotes) {
      return []
    }

    return crackInjectionFootnotes.reduce((result, item) => {
      if (products.includes(item.product)) {
        result.push(item.htmlText)
      }
      return result
    }, [])
  }

  return {
    getModels,
    getApitchOrArebar,
    getInsertDiameterOptions,
    getProductOptions,
    getDrillBitDiameterOptions,
    getProductInfo,
    getProductImage,
    getProductImages,
    getScreenTubeOptions,
    showWaterFilledHolesInput,
    getInjectionResinCrackWidthList,
    getCrackInjectionModels,
    getCrackInjectionFootnotes,
  }
}
